import { fadeInit, fadeAnim } from './animations/fade';
import { staggerListInit, staggerListAnim } from './animations/staggerList';

const initial = new Map();
initial.set('fade', fadeInit);
initial.set('staggerList', staggerListInit);

const animations = new Map();
animations.set('fade', fadeAnim);
animations.set('staggerList', staggerListAnim);


export { animations, initial };
